module.exports = ":host{\n  display:flex;\n  align-items: end;\n}\n\n.footer-content {\n  padding-top: 5px;\n}\n"